import { render, staticRenderFns } from "./Aviso.vue?vue&type=template&id=a53dff78&scoped=true&"
import script from "./Aviso.vue?vue&type=script&lang=js&"
export * from "./Aviso.vue?vue&type=script&lang=js&"
import style0 from "./Aviso.vue?vue&type=style&index=0&id=a53dff78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53dff78",
  null
  
)

export default component.exports